/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { Type } from "@sinclair/typebox";
import { Format } from "../schema-index/index.js";
export const EncodedSchemaChange = Type.Object({
    new: Format,
    old: Format,
});
//# sourceMappingURL=schemaChangeFormat.js.map